import React from 'react';
import { LazyBreadcrumb } from '@europrocurement/flexy-components';
import { Container } from '@mui/material';
import { REALM_PRESCRIPTEUR, UseKeycloakService } from '@europrocurement/l2d-keycloak';
import { useNavigate } from 'react-router';
import { dossiersBasePath } from '@europrocurement/l2d-modules';

const Accueil = function () {
    const keycloakService = UseKeycloakService();
    // Roles
    const isExternePrescripteur = keycloakService.checkRole(REALM_PRESCRIPTEUR);

    const navigate = useNavigate();

    React.useEffect(() => {
        if (isExternePrescripteur) {
            navigate(`/${dossiersBasePath}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Container maxWidth="xl">
            <LazyBreadcrumb path={[{ path: 'Accueil', link: '/accueil' }, 'Dashboard']} />
        </Container>
    );
};
export default Accueil;
